import { rootRoute } from '@/modules/core/root/route';
import { createRoute, redirect } from '@tanstack/react-router';

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: async ({ context }) => {
    await context.auth.checkAuth();
    if (context.auth.isAuthenticated()) {
      throw redirect({
        to: '/charge-center',
        replace: true,
      });
    }

    throw redirect({
      to: '/login',
      replace: true,
    });
  },
});
